/* eslint-disable @typescript-eslint/no-explicit-any */
import { v4 as uuidv4 } from 'uuid';
import mixpanel from 'mixpanel-browser';
import { EVENTS_CONFIG, SHOW_LOGS } from 'config';
// import MixpanelProvider from './Providers/Mixpanel.provider';
import LoggerSaverClass from './LoggerServer';
import EventProviders, { EventType, IEventEventProvider, IEventProviders } from './@types';

/**
 * Show the list of the available provider trackers
 *
 * @const array
 */

interface IProviderAdapters {
  [x: string]: any;
}

const ProviderAdapters: IProviderAdapters = {
  [EventProviders.MIXPANEL]: (type: string, { tag, params }: IEventEventProvider): void =>
    mixpanel.track(tag, { ...params }),
};

/**
 * Get the original instance of the Event tracker
 * for example mixpanel would return an instance from 'mixpanel-browser';
 * @param eventProviderName
 */
const getEventProviderInstance = (providerName: IEventProviders): any => {
  let instance;
  switch (providerName) {
    case IEventProviders.MIXPANEL:
      instance = mixpanel;
      break;

    default:
      instance = undefined;
      break;
  }
  return instance;
};

/**
 * The default tracker providers
 * @const array
 */
const defaultProviders = [EventProviders.MIXPANEL];

const loggerSaver = new LoggerSaverClass();

/**
 *
 * @param type Type of event e.g. View, Action.
 * @param event Contains the information of the event.
 * @param providers List of the event trackers that will dispatch the event.
 */
const report = (type: string, event: IEventEventProvider, providers: IEventProviders[] = defaultProviders): void => {
  if (SHOW_LOGS) {
    console.info({ ...event, providers, id: uuidv4() });
  }
  loggerSaver.saveToLogger({ ...event, providers, id: uuidv4() });
  providers.map((provider: IEventProviders) => ProviderAdapters[provider](type, event));
};

/**
 * The function used to create an event action
 * @const array
 */
const action = (event: IEventEventProvider, providers?: Array<IEventProviders>): void =>
  report(EventType.ACTION, event, providers);

/**
 * The function used to create an event view
 * @const array
 */
const view = (event: IEventEventProvider, providers?: Array<IEventProviders>): void =>
  report(EventType.VIEW, event, providers);

/**
 * Send the user's information to the event trackers to identify it.
 * @param user the user logged
 */
const setUserAttributes = (user: any): void => {
  mixpanel.people.set(user);
};

const initialize = (): void => {
  mixpanel.init(EVENTS_CONFIG.MIXPANEL.KEY);
  if (SHOW_LOGS) {
    console.info('%cℹ️ PROVIDERS INITIALIZED', 'background: #006579; color: #c2f5ff; font-size: 11px');
  }
};

const EventReporter = {
  initialize,
  action,
  view,
  report,
};

export default EventReporter;
export {
  setUserAttributes,
  loggerSaver,
  defaultProviders,
  getEventProviderInstance,
};
